export const SAVE_PERSISTENT_STATE = "SAVE_PERSISTENT_STATE";
